import React from "react";
import DefaultPageWrapper from "../templates/DefaultPageWrapper";
import NavBar from "../components/NavBar";
import HeroBlockDark from "../components/HeroBlockDark";
import HeroImage from "../images/heros-and-graphics/earth-night-nasa-unsplash-hero.jpeg";
import AboutStory from "../components/AboutStory";
import AboutIntro from "../components/AboutIntro";
import Timeline from "../components/Timeline";
import Newsletter from "../components/Newsletter";
import Footer from "../components/Footer";

const About = () => {
  return (
    <DefaultPageWrapper
      title="About | Rho Impact"
      description="Rho Impact is built on over a decade applying data to solve real-world challenges."
    >
      {/*  Site header */}
      <NavBar theme="dark" />
      {/*  Page content */}
      <main className="flex-grow">
        {/*  Page sections */}
        <HeroBlockDark
          heroImage={HeroImage}
          titleText="We Help the<br />Best Climate Solutions Win"
          subtitleText=""
          opacityClass="opacity-75"
        />
        <AboutIntro />
        <AboutStory />
        <Timeline />
        <Newsletter
          title="Ready to make an impact?"
          subtitle="Sign up to receive updates on our latest products and research."
        />
        {/*
        <Career />
         */}
      </main>
      {/*  Site footer */}
      <Footer />
    </DefaultPageWrapper>
  );
};

export default About;
